import styled from '@themes/theme'

export const VocModalWrap = styled.div`
  z-index: 1;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%,-58%);
  width: 282px;
  .voc-modal-img {
    width: 282px;
    height: auto;
  }
  .voc-modal-close-btn {
    position: absolute;
    top: 49px;
    right: 10px;
    width: 30px;
    height: 30px;
    background: none;
  }
  .voc-modal-txt {
    margin: 20px auto;
    font-size: ${props=>props.theme.font.large};
    color: #fff;
    &--point-color {
     font-size: ${props=>props.theme.font.large};
     color: #00cdff;
    }
  }
  .voc-modal-btn {
    width: 232px;
    height: 32px;
  }
`
